import { css } from "@emotion/react";

export const styles = {
  drawer__divider: css`
    margin-left: 16px;
    margin-right: 16px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  `
};
